
import $ from 'jquery';

import 'jquery.easing';
import 'intersection-observer';

import debounce from './util/debounce';
import globals from './global/globals';
import globalelements from './global/elements';
import logger from './logger';


export default function (options) {
    var o = $.extend({
        filternavColSelector: '.filternav__col',
        filternavColContentSelector: '.filternav__col__content',
        devMode: true
    }, options);


    var ele = {
        header: $('header'),

        stickySentinal: $('[data-header-stickydist]'),
        sectionsWithDefinedColor: globalelements.sectionsWithDefinedColor,

        subnavTrigger: $('#subnav-trigger'),
        filternavTrigger: $('#filternav-trigger'),
        phonenavLinks: $('.hide-when-filternav-visible-phone'),
        filternavColContentTrigger: $('.filternav__col__content-trigger'),

        filternavCols: $(o.filternavColSelector)
    };


    var internal = {
        name: 'Header',

        primaryColor: globalelements.body.attr('data-primary-color'),

        stickyHeaderObserver: null,
        sectionColorObserver: null,

        subnavOpen: false,
        filterNavMenuVisible: false
    };


    var fn = {
        init: function () {
            fn.setupStickyHeaderObserver(null);
            fn.setupSectionColorObserver();

            globalelements.win.on('resize', debounce(handlers.resize, 100));

            ele.subnavTrigger.on('click', handlers.subnavTriggerClick);
            ele.filternavTrigger.on('click', handlers.filternavTriggerClick);
            ele.filternavColContentTrigger.on('click', handlers.filternavColContentTriggerClick);
        },

        setupStickyHeaderObserver: function () {
            internal.stickyHeaderObserver = new window.IntersectionObserver(handlers.stickyHeaderObserverHandler);
            internal.stickyHeaderObserver.observe(ele.stickySentinal[0]);
        },

        setupSectionColorObserver: function () {
            // watches for any section with a defined text color to
            // see whether the header should invert or not
            var config = {
                root: null,
                rootMargin: '0% 0% -100% 0%',
                threshold: 0
            };

            internal.sectionColorObserver = new window.IntersectionObserver(function (entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        var text = entry.target.dataset.text;
                        var bg = entry.target.dataset.bg;

                        if (bg && bg.length === 7) {
                            globalelements.header.css('background', fn.convertHexToRGBA(bg, 96));
                        } else if (bg && bg === 'transparent') {
                            globalelements.header.css('background', 'transparent');
                        } else {
                            globalelements.header.css('background', '');
                        }

                        if (bg === internal.primaryColor) {
                            globalelements.body.attr('data-header-bg-is-primary', '');
                        } else {
                            globalelements.body.removeAttr('data-header-bg-is-primary');
                        }

                        if (text === 'white') {
                            globalelements.body.attr('data-header-invert', 'true');
                        } else {
                            globalelements.body.attr('data-header-invert', 'false');
                        }
                    }
                });
            }, config);

            ele.sectionsWithDefinedColor.each(function () {
                internal.sectionColorObserver.observe($(this)[0]);
            });
        },

        showSubnav: function () {
            internal.subnavOpen = true;
            globalelements.body.attr('data-subnav-open', 'true');
        },
        hideSubnav: function () {
            internal.subnavOpen = false;
            globalelements.body.attr('data-subnav-open', 'false');
        },

        showFilternavColContent: function (cols) {
            cols = cols || ele.filternavCols;

            cols.attr('data-show-content-phone', 'true')
                .find(o.filternavColContentSelector)
                .slideDown(globals.anim.hoverSpeed, globals.anim.easing);
        },
        hideFilternavColContent: function (cols) {
            cols = cols || ele.filternavCols;

            cols.attr('data-show-content-phone', 'false')
                .find(o.filternavColContentSelector)
                .slideUp(globals.anim.hoverSpeed, globals.anim.easing);
        },

        convertHexToRGBA: function (hex, opacity) {
            hex = hex.replace('#', '');
            var r = parseInt(hex.substring(0, 2), 16);
            var g = parseInt(hex.substring(2, 4), 16);
            var b = parseInt(hex.substring(4, 6), 16);

            return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
        },

        console: function (msgs) {
            logger(msgs, {
                enabled: o.devMode,
                prefix: internal.name + '.js',
                prefixColor: 'cyan'
            });
        }
    };


    var handlers = {
        resize: function () {
            var isPhone = (window.outerWidth <= globals.breakpoints.phoneMax);

            if (isPhone) {
                fn.hideFilternavColContent();
            } else {
                fn.showFilternavColContent();
            }
        },
        stickyHeaderObserverHandler: function (entries) {
            if (!entries[0].isIntersecting) {
                ele.header.addClass(globals.classes.state.sticky);
            } else {
                ele.header.removeClass(globals.classes.state.sticky);
            }
        },
        subnavTriggerClick: function () {
            if (internal.subnavOpen) {
                fn.hideSubnav();
            } else {
                fn.showSubnav();
            }
        },
        filternavTriggerClick: function () {
            internal.filterNavMenuVisible = !internal.filterNavMenuVisible;
            ele.header.attr('data-filternav-visible', internal.filterNavMenuVisible);
            ele.phonenavLinks.slideToggle(globals.anim.hoverSpeed, globals.anim.easing);
        },
        filternavColContentTriggerClick: function (e) {
            var currentCol = $(this).closest(o.filternavColSelector);
            var currentColVisible = (currentCol.attr('data-show-content-phone') === 'true');

            fn.hideFilternavColContent(ele.filternavCols.filter('[data-show-content-phone=true]'));

            if (!currentColVisible) {
                fn.showFilternavColContent(currentCol);
            }
        }
    };


    fn.init();
}
